import {useEffect, useState} from 'react';
import {withTranslation, WithTranslation} from 'react-i18next';

import {ConfirmModal, AssignmentSelectors} from 'components';
import {AccountAssignmentInfo, Group} from 'interfaces';
import {TRANSLATION_KEYS} from 'locale';

type Props = {
    open: boolean;
    selectedGroupId?: string;
    selectedSubgroupId?: string;
    groups?: Group[];
    loading?: boolean;
    groupDisabled?: boolean;
    onClose: (value: boolean, assignment?: AccountAssignmentInfo) => void;
} & WithTranslation;

const T_KEYS = TRANSLATION_KEYS.COMPONENTS.ASSIGNMENT_SELECTION_MODAL;

const AssignmentSelectionModal: React.FC<Props> = (props: Props) => {
    const [assignment, setAssignment] = useState<AccountAssignmentInfo>(null);

    useEffect(() => {
        if (props.open) {
            setAssignment({
                groupId: props.selectedGroupId,
                subgroupId: props.selectedSubgroupId
            });
        }
    }, [setAssignment, props.open, props.selectedGroupId, props.selectedSubgroupId]);

    const onChangeAssignment = (groupId: string, subgroupId: string) => {
        setAssignment({groupId, subgroupId});
    };

    const onCloseModal = (value: boolean) => {
        props.onClose(value, value ? assignment : null);
    };

    return (
        <ConfirmModal
            open={props.open}
            title={props.t(T_KEYS.TITLE)}
            maxWidth='sm'
            fullWidth
            okDisabled={props.loading}
            onClose={onCloseModal}
        >
            <AssignmentSelectors
                selectedGroupId={assignment?.groupId}
                selectedSubgroupId={assignment?.subgroupId}
                groups={props.groups}
                disabled={props.loading}
                groupDisabled={props.groupDisabled}
                fullWidth
                onChange={onChangeAssignment}
            />
        </ConfirmModal>
    );
};

const wrappedComponent = withTranslation()(AssignmentSelectionModal);

export {wrappedComponent as AssignmentSelectionModal};